import { SortDirection } from "./UI/Enums";

class PaginationSettings<T> {
    public OrderType: T;
    public OrderDirection: SortDirection;
    public TotalCount: number;
    public PageSize: number;
    public Offset: number;

    public constructor(defaultOrderType: T) {
        return {
            OrderType: defaultOrderType,
            OrderDirection: SortDirection.DESC,
            TotalCount: 0,
            PageSize: 10,
            Offset: 0
        };
    }
}

export { PaginationSettings };
